import { TmFormError } from '@/core/error/tmFormError'

export class TmNonExistFormError extends TmFormError {
  public name = 'TmNonExistFormError'
}
